module.exports = __webpack_public_path__ + "static/media/slide.42ee5220.svg";